import { Cancel } from '@mui/icons-material';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	IconButton,
	TextField,
} from '@mui/material';
import React, { ChangeEvent, FC, useCallback, useEffect, useState } from 'react';
import { useTranslation } from '../../services';

const RejectStudyRequest: FC<{ callback: (value: boolean, notes: string) => void }> = ({
	callback,
}) => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const [notes, setNotes] = useState('');
	const [error, setError] = useState<boolean>(false);
	const handleNotesChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			const val = e.target.value;
			setNotes(val);
		},
		[setNotes]
	);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = useCallback(
		(reject: boolean) => {
			if (!error) {
				callback(reject, notes);
				setOpen(false);
				setNotes('');
			} else if (!reject) {
				callback(reject, notes);
				setOpen(false);
				setNotes('');
			}
		},
		[callback, notes, error]
	);

	useEffect(() => {
		if (notes === '') {
			setError(true);
		} else {
			setError(false);
		}
	}, [notes]);

	return (
		<>
			<IconButton
				onClick={handleClickOpen}
				title={t('Reject request')}
				color="error"
			>
				<Cancel />
			</IconButton>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>{t('Reject request')}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{t(
							'Please describe the reason, why the request should be rejected.'
						)}
					</DialogContentText>
					<TextField
						autoFocus
						required
						margin="dense"
						onChange={handleNotesChange}
						id="notes"
						value={notes}
						label={t('Reason')}
						error={error}
						helperText={error && t('"Reason" is a required field')}
						type="text"
						fullWidth
						multiline
						variant="standard"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleClose(false)}>{t('No')}</Button>
					<Button onClick={() => handleClose(true)}>{t('Yes')}</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default RejectStudyRequest;
